import NodeWarOCR from "./components/NodeWarOCR";

function App() {
  return <NodeWarOCR />;
}

export default App;